export const detectResignationIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete resignation" || cleaned === "remove resignation") {
        return { intent: "delete_resignation" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) resignation/);
    if (deleteMatch) {
        return { intent: "delete_resignation", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create resignation") || cleaned.includes("add resignation")) {
        return { intent: "create_resignation" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create resignation named (.+)/);
    if (createMatch) {
        return { intent: "create_resignation", name: createMatch[1].trim() };
    }

    return null;
};
